import React from 'react'

import { FormattedMessage, useIntl } from '@divvy-web/i18n'

import MarketingContent, { MarketingQuestionAndAnswer, PrivacyPolicyLink } from '@sputnik/components/MarketingContent'

const NameAndOwnershipFormMarketingContent = () => {
  const { formatMessage } = useIntl()

  return (
    <MarketingContent
      footer={<PrivacyPolicyLink />}
      image={{
        alt: formatMessage({
          defaultMessage: 'person looking hopefully into the distance while writing on a notepad',
          id: 'sputnik.NameAndOwnershipFormMarketingContent__BZkptf',
        }),
        src: 'https://app.divvy.co/assets/stock-photos/credit-application-name-and-ownership-marketing-content.png',
      }}
      pillText={
        <FormattedMessage
          defaultMessage='Insight'
          id='sputnik.NameAndOwnershipFormMarketingContent__i2N9jB'
        />
      }
    >
      <MarketingQuestionAndAnswer
        answer={
          <FormattedMessage
            defaultMessage='Like any credit application, we need to verify your business and financial information to get started. We know it may feel a lot, so we provided this help article to explain what we’re asking for and why. Rest assured, your data belongs to you. We do not sell personal or business info and will only use it for verification purposes.'
            id='sputnik.NameAndOwnershipFormMarketingContent__/GIq3q'
          />
        }
        question={
          <FormattedMessage
            defaultMessage='Why do we need this information?'
            id='sputnik.NameAndOwnershipFormMarketingContent__jQ+e1J'
          />
        }
      />
    </MarketingContent>
  )
}

export default NameAndOwnershipFormMarketingContent
